module.exports = __webpack_public_path__ + "static/media/ALTHAR_WEB_Advisory-Boards.8cfcc8bb.png";